<div class="flex items-center gap-3">
  <mat-icon class="icon-size-6 shrink-0">task_alt</mat-icon>
  <span class="flex-1 text-base leading-relaxed" [innerHTML]="data.message"></span>
  @if (data.serials?.length) {
  <button mat-icon-button type="button" class="shrink-0"
    [matTooltip]="(copied ? 'DOCUMENT_GENERATE.CREATED_SNACKBAR.COPIED' : 'DOCUMENT_GENERATE.CREATED_SNACKBAR.COPY_SERIALS') | t"
    (click)="copySerials()">
    <mat-icon>{{ copied ? 'check' : 'content_copy' }}</mat-icon>
  </button>
  }
  <button mat-button type="button" class="shrink-0" (click)="close()">
    {{ 'GENERAL.CLOSE' | t }}
  </button>
</div>
